"use client";

import { useTranslations } from 'next-intl';
import Button from '../Button/Button';

function HighLights() {
  const t = useTranslations('home.highlights');

  const highLightsData = {
    title: t('title'),
    cards: [
      { title: t('cards.ultimateGift.title'), description: t('cards.ultimateGift.description'), bg: '#FFECC9' },
      { title: t('cards.aiPowered.title'), description: t('cards.aiPowered.description'), bg: '#FFDEA0' },
      { title: t('cards.customMade.title'), description: t('cards.customMade.description'), bg: '#FFD078' }
    ],
    button: t('button')
  };

  return highLightsData ? (
    <div className="bg-pink w-full">
      <div className="w-full max-w-[1260px] mx-auto px-10 md:px-4 section-py" id="highlights">
        <h2 className="text-title text-center">{highLightsData.title}</h2>
        <div className=" grid grid-cols-1 lg:grid-cols-3 gap-x-2 gap-y-[35px] justify-items-center max-w-[1040px] w-full mx-auto mt-9 md:mt-12">
          {Array.isArray(highLightsData?.cards) && highLightsData.cards.map((card, index) => (
            <div className="text-center h-[293px] text-[#2B2B2B] w-[293px] rounded-full shadow-[0_3px_8px_4px_rgba(0,0,0,0.25)]" key={index}
              style={{ background: `${card.bg}` }}>
              <div className="gap-3 flex flex-col items-center justify-center h-full">
                <div className="text-[18px] font-bold">{card.title}</div>
                <div className=" mx-10">{card.description}</div>
              </div>
            </div>
          )
          )}

        </div>
        <div className="hidden md:block mt-16">
          <Button text={highLightsData.button} />
        </div>
      </div>

    </div>
  ) : null;
}

export default HighLights
